import { call, put } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { DAY_MS } from 'constants/time-and-date';
import { setUserSelectedLocation } from 'redux/modules/locale';
import { writeLocalStorage } from './local-storage';

export function* persistUserLocation(lat, lon) {
  if (!lat || !lon || (lat === 0 && lon === 0)) {
    yield call(logger.warn, 'Location: Failed with persisting invalid lat and lon values', lat, lon);
    return;
  }

  try {
    yield put(setUserSelectedLocation(lat, lon));
    yield call(writeLocalStorage, 'userLocation', {
      lat,
      lon,
      expires: Date.now() + DAY_MS * 30,
    });
  } catch (error) {
    /* noop */
  }
}
